const getQuotePayload = function (cat, store) {
  let data = {};

  let payload = {
    category_id: null,
  };

  try {
    switch (cat) {
      case "visitor-insurance":
        data = store.getters.quote_data.visitor;
        payload.category_id = 1;
        payload.traveler_details = data.travelers.map((item) => ({
          age: item["age"],
          dob: item["dob"],
          citizenship: item["citizenship"],
          residency: item["residence"],
        }));
        payload.destination = data.destinations.map((item) => item["value"]);
        payload.coverage_start_date = data.coverage_dates.start_date;
        payload.coverage_end_date = data.coverage_dates.end_date;
        break;
      case "student-insurance":
        data = store.getters.quote_data.student;
        payload.category_id = 3;
        payload.traveler_details = data.travelers.map((item) => ({
          age: item["age"],
          dob: item["dob"],
          citizenship: item["citizenship"],
          residency: item["residence"],
        }));
        payload.destination = [data.destination];
        payload.state = data.destination_state;
        payload.coverage_start_date = data.coverage_dates.start_date;
        payload.coverage_end_date = data.coverage_dates.end_date;
        break;
      case "immigrant-insurance":
        data = store.getters.quote_data.immigrant;
        payload.category_id = 4;
        payload.traveler_details = data.travelers.map((item) => ({
          age: item["age"],
          dob: item["dob"],
          citizenship: item["citizenship"],
          residency: item["residence"],
        }));
        payload.state = data.destination_state;
        payload.destination = [data.destination];
        payload.coverage_start_date = data.coverage_dates.start_date;
        payload.coverage_end_date = data.coverage_dates.end_date;
        break;
      case "j1-insurance":
        data = store.getters.quote_data.j1;
        payload.category_id = 12;
        payload.traveler_details = data.travelers.map((item) => ({
          age: item["age"],
          dob: item["dob"],
          citizenship: item["citizenship"],
          residency: item["residence"],
        }));
        payload.state = data.destination_state;
        payload.destination = [data.destination];
        payload.coverage_start_date = data.coverage_dates.start_date;
        payload.coverage_end_date = data.coverage_dates.end_date;
        break;
      case "schengen-insurance":
        data = store.getters.quote_data.schengen;
        payload.category_id = 14;
        payload.traveler_details = data.travelers.map((item) => ({
          age: item["age"],
          dob: item["dob"],
          citizenship: item["citizenship"],
          residency: item["residence"],
        }));
        payload.destination = data.destinations.map((item) => item["value"]);
        payload.coverage_start_date = data.coverage_dates.start_date;
        payload.coverage_end_date = data.coverage_dates.end_date;
        break;
      case "trip-insurance":
        data = store.getters.quote_data.trip;
        payload.category_id = 15;
        payload.traveler_details = data.travelers.map((item) => ({
          age: item["age"],
          dob: item["dob"],
          tripCost: item["trip_cost"],
        }));
        payload.residency = data.travelers[0]?.residence_country ?? null;
        payload.state = data.travelers[0]?.residence_state ?? null;
        payload.destination =
          data.destinations?.map((item) => item["value"]) ?? null;
        payload.coverage_start_date = data.coverage_dates?.start_date ?? null;
        payload.coverage_end_date = data.coverage_dates?.end_date ?? null;
        payload.deposit_date = data?.trip_deposit_date ?? null;
        payload.total_trip_cost = data?.total_trip_cost ?? null;
        payload.iscfar_enabled = store.getters.iscfar_enabled ?? null;
        break;
      case "preex-insurance":
        data = store.getters.quote_data.preex;
        payload.category_id = 34;
        payload.traveler_details = data.travelers.map((item) => ({
          age: item["age"],
          dob: item["dob"],
          citizenship: item["citizenship"],
          residency: item["residence"],
        }));
        payload.destination = data.destinations.map((item) => item["value"]);
        payload.coverage_start_date = data.coverage_dates.start_date;
        payload.coverage_end_date = data.coverage_dates.end_date;
        break;
      case "add-insurance":
        data = store.getters.quote_data.addnd;
        payload.category_id = 31;
        payload.traveler_details = data.travelers.map((item) => ({
          age: item["age"],
          dob: item["dob"],
          citizenship: item["citizenship"],
          residency: item["residence"],
        }));
        payload.destination = data.destinations.map((item) => item["value"]);
        payload.coverage_start_date = data.coverage_dates.start_date;
        payload.coverage_end_date = data.coverage_dates.end_date;
        break;
      case "medical-evacuation-insurance":
        data = store.getters.quote_data.medevac;
        payload.category_id = 28;
        payload.traveler_details = data.travelers.map((item) => ({
          age: item["age"],
          dob: item["dob"],
          citizenship: item["citizenship"],
          residency: item["residence"],
        }));
        payload.destination = data.destinations.map((item) => item["value"]);
        payload.coverage_start_date = data.coverage_dates.start_date;
        payload.coverage_end_date = data.coverage_dates.end_date;
        break;
      case "opt-student-insurance":
        data = store.getters.quote_data.optstudent;
        payload.category_id = 18;
        payload.traveler_details = data.travelers.map((item) => ({
          age: item["age"],
          dob: item["dob"],
          citizenship: item["citizenship"],
          residency: item["residence"],
        }));
        payload.state = data.destination_state;
        payload.destination = [data.destination];
        payload.coverage_start_date = data.coverage_dates.start_date;
        payload.coverage_end_date = data.coverage_dates.end_date;
        break;
      case "cruise-insurance":
        data = store.getters.quote_data.cruise;
        payload.category_id = 32;
        payload.traveler_details = data.travelers.map((item) => ({
          age: item["age"],
          dob: item["dob"],
          tripCost: item["trip_cost"],
        }));
        payload.residency = data.travelers[0]?.residence_country ?? null;
        payload.state = data.travelers[0]?.residence_state ?? null;
        payload.destination =
          data.destinations.map((item) => item["value"]) ?? null;
        payload.coverage_start_date = data.coverage_dates?.start_date ?? null;
        payload.coverage_end_date = data.coverage_dates?.end_date ?? null;
        payload.deposit_date = data?.trip_deposit_date ?? null;
        payload.total_trip_cost = data?.total_trip_cost ?? null;
        break;
    }
  } catch (error) {
    console.error(error);
    payload = {};
  }

  return payload;
};

export default getQuotePayload;
